export enum ActionResponseState {
  Processing = 'processing',
  Success = 'success',
  Failure = 'failure',
  Info = 'info',
}
